import PermissionError from "../components/error/permission-error/PermissionError";
import LoadingOverlay from "../components/loadingoverlay/LoadingOverlay";
import { useFeatures } from "./featureContext";

const ProtectedRoute = ({ allowedFeature, children }) => {
    const { features, loading } = useFeatures();
    if (loading) {
        return <LoadingOverlay />;
    }

    const allowedFeatures = Array.isArray(allowedFeature)
        ? allowedFeature
        : [allowedFeature];

    const hasAccess = allowedFeatures.some(feature =>
        features.includes(feature)
    );

    if (!hasAccess) {
        return <PermissionError />;
    }

    return children;
};

export default ProtectedRoute;
